import { withNamespaces } from "react-i18next";
import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner,
} from "reactstrap";

const DeleteFunctionModal = ({
    t,
    isOpen,
    toggle,
    organizationFunction,
    onConfirm,
    isDeleting,
}) => (
    <Modal isOpen={isOpen} backdrop="static">
        <ModalHeader toggle={toggle}>{t("Delete Function")}</ModalHeader>
        <ModalBody>
            {t("Are you sure you want to delete this Function?")}
            {organizationFunction?.title ? (
                <>
                    <br />
                    <strong>{organizationFunction.title}</strong>
                </>
            ) : null}
            <br />
            {t("This action cannot be undone.")}
        </ModalBody>
        <ModalFooter>
            <Button color="secondary" type="button" onClick={toggle}>
                {t("Cancel")}
            </Button>
            <Button
                color="danger"
                type="button"
                disabled={isDeleting}
                onClick={onConfirm}
            >
                {isDeleting ? (
                    <Spinner className="me-2" size="sm" color="light" />
                ) : null}
                {t("Delete Function")}
            </Button>
        </ModalFooter>
    </Modal>
);

export default withNamespaces()(DeleteFunctionModal);
